import React from "react";
import PropTypes from "prop-types";
import Chart from "react-apexcharts";
import { ChartWrapper, Placeholder } from "./styles/chart-styles";

const Bar = ({ graphOptions, dataTestId, placeholderHidden }) => {
  const { options, series } = graphOptions;

  return (
    <ChartWrapper className="chart-item" data-test-id={dataTestId}>
      {series.length > 0 ? (
        <Chart
          options={options}
          series={series}
          height={options.height}
          // width={options.width}
          type="bar"
          data-test-id="bar-chart-test-id"
        />
      ) : (
        <Placeholder
          data-test-id="bar-chart-placeholder"
          hidden={placeholderHidden}
        >
          No results found
        </Placeholder>
      )}
    </ChartWrapper>
  );
};

Bar.propTypes = {
  graphOptions: PropTypes.shape({
    options: PropTypes.shape({}),
    series: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  height: PropTypes.number,
  width: PropTypes.number,
  dataTestId: PropTypes.string,
  placeholderHidden: PropTypes.bool,
};

Bar.defaultProps = {
  dataTestId: PropTypes.isNull,
  height: PropTypes.isNull,
  width: PropTypes.isNull,
  placeholderHidden: PropTypes.isNull,
};

export default Bar;
